// Dynamic API URL that adapts to current host
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Use current hostname but change port from 8001 to 5001
  const currentHost = window.location.hostname;
  const protocol = window.location.protocol;
  return `${protocol}//${currentHost}:5001`;
};

export const API_URL = getApiUrl();
